import { render, staticRenderFns } from "./EditableText.vue?vue&type=template&id=2577d94a&lang=pug&"
import script from "./EditableText.vue?vue&type=script&lang=ts&"
export * from "./EditableText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports